import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { CaseService } from "@js/services/CaseService";
import { RoleService } from "@js/services/RoleService";
import {
  Case,
  CaseClient,
  CaseMember,
  CaseMemberClient,
  DevelopmentTrackRecord,
  DevelopmentTrackRecordClient,
  FileAttachment,
  FileAttachmentClient,
  ModuleEnum,
  ProjectOwnership,
  StreetAddressClient,
  UserClient,
  ProjectOwnershipClient,
  PostalAddress,
  AddressLookupDTO,
  ApplicationUserCrudClient,
  ProjectOwnershipCrudClient,
  CaseCrudClient,
  CaseInsert,
  OwnerOrEmployeeEnum,
  FileAttachmentCrudClient,
  DevelopmentTrackRecordCrudClient,
} from "@src/apis/ModularClient";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { AddressHistoryDTO } from "@js/DTO/AddressHistoryDTO.cs";
import { DevelopmentTrackRecordTypeEnum } from "@js/models/enum/DevelopmentTrackRecordTypeEnum.cs";
import { Expand, getOneUsingOData } from "@ccq/ts-lib";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class TrackRecordController {
  //case id
  caseid: number;

  development: Expand<ProjectOwnership, { readonly developmentTrackRecords: true }>;
  developmentTrackRecordType: {}[] = [];

  //navigate for pages
  step: number = 3;
  applicantNo: number = 0;
  devexperienceId: number;

  //current case
  case: Expand<Case, { readonly attachments: true; readonly developmentInput: true }>;
  caseTitle: string;

  //share shareholder
  shareContext: number = null;
  shareSuplId: number = null;
  userFirstName: string;
  shareNote: string;
  shareFirstName: string;
  shareSurname: string;
  shareEmail: string;
  showShare: boolean = false;

  saving: boolean = false;
  saved: boolean = false;
  error: boolean = false;
  dataLoading: boolean = false;

  //calculations
  total: number = 0;

  //modal
  message: string = "";
  modal: boolean = false;
  openModal: boolean = false;

  owners: CaseMember[];
  currentApplicant: CaseMember;

  //files
  fileUpload: Expand<FileAttachment>[];
  uploadingFiles: FileUploadProgressDTO[];
  thisModuleSection: ModuleEnum = ModuleEnum.ApplicantDetails;

  //forms
  multiPartForm4: ng.IFormController;
  multiPartForm7: ng.IFormController;

  //address
  previousAddressSearchTerm: string;
  searchingForPreviousAddress: boolean = false;
  previousAddressPostCodeOptions: PostalAddress[] = [];
  showAddHistoryConfirmDelete: boolean = false;
  addressHistoryIdToDelete: number;
  showAddressHistoryModal: boolean = false;
  shareholderAddressHistory: AddressHistoryDTO[] = [];
  addressHistoryItem: AddressHistoryDTO;
  previousAddressSearchResults: string[];
  searchpostcode: string[];
  searchterm: string[];
  searchresults: string[];
  PostCodeOptions: PostalAddress[][] = [];
  searchingForAddress: boolean = false;

  //current shareholder
  currentShareholder: CaseMember;

  formattedAcquisitionDate: any[] = [];

  caseMembersWithAccess: CaseMember[];
  selectedClientToShareWith: CaseMember;

  static $inject = [
    "$location",
    "RoleService",
    "$rootScope",
    "$q",
    "StreetAddressClient",
    "DevelopmentTrackRecordClient",
    "CaseMemberClient",
    "$routeParams",
    "CaseService",
    "CaseClient",
    "FileAttachmentClient",
    "FileAttachmentHelper",
    "$window",
    "$scope",
    "UserClient",
    "ProjectOwnershipClient",
    "IndexService",
    "ApplicationUserCrudClient",
    "ProjectOwnershipCrudClient",
    "CaseCrudClient",
    "ODataHelper",
    "FileAttachmentCrudClient",
    "DevelopmentTrackRecordCrudClient",
  ];

  constructor(
    private $location: ng.ILocationService,
    private roleService: RoleService,
    private $rootScope: ng.IRootScopeService,
    protected $q: ng.IQService,
    private streetAddressClient: StreetAddressClient,
    private developmenttrackrecordClient: DevelopmentTrackRecordClient,
    private caseMemberClient: CaseMemberClient,
    private $routeParams: ng.route.IRouteParamsService,
    private caseService: CaseService,
    private caseClient: CaseClient,
    private fileAttachmentClient: FileAttachmentClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private $window: ng.IWindowService,
    private $scope: ng.IScope,
    private $userClient: UserClient,
    private $projectOwnershipClient: ProjectOwnershipClient,
    private indexService: IndexService,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private projectOwnershipCrudClient: ProjectOwnershipCrudClient,
    private caseCrudClient: CaseCrudClient,
    private odataHelper: ODataHelper,
    private fileAttachmentCrudClient: FileAttachmentCrudClient,
    private developmentTrackRecordCrudClient: DevelopmentTrackRecordCrudClient,
  ) {
    this.odataHelper
      .getOne(this.projectOwnershipCrudClient, {
        filter: {
          id: {
            eq: Number(this.$routeParams.Id),
          },
        },
      })
      .then((response) => {
        this.odataHelper
          .getMany(this.developmentTrackRecordCrudClient, {
            filter: {
              developmentExperienceId: {
                eq: Number(this.$routeParams.Id),
              },
            },
          })
          .then((developmentTrackRecords) => {
            this.devexperienceId = this.$routeParams.Id;
            this.development = response as typeof response & { developmentTrackRecords: any[] };
            this.development.developmentTrackRecords = developmentTrackRecords;
            //Update track record development types#
            this.initDevelopmentTrackRecordTypes();
          });
      });

    if (this.$routeParams.ApplicantNo) {
      this.currentApplicant = this.owners[this.$routeParams.ApplicantNo];
    }

    if (this.$routeParams.CaseId) {
      this.caseid = this.$routeParams.CaseId;

      this.odataHelper
        .getOne(this.caseCrudClient, {
          filter: {
            id: {
              eq: Number(this.$routeParams.CaseId),
            },
          },
          expand: {
            developmentInput: true,
          },
        })
        .then((result) => {
          this.odataHelper
            .getMany(this.fileAttachmentCrudClient, {
              filter: {
                caseId: {
                  eq: Number(this.$routeParams.CaseId),
                },
              },
            })
            .then((attachments) => {
              this.case = result as typeof result & { attachments: any[] };
              this.case.attachments = attachments;
              this.caseTitle = result.developmentInput.searchName;
              this.fileUpload = attachments;
            });
        });
    }

    /*  $scope.$on('$locationChangeStart', (event: ng.IAngularEvent) => {
                localStorage.setItem('DevelopmentTrackRecords', JSON.stringify(this.development.developmentTrackRecords));
            });*/
  }

  onFileSelect(files: FileAttachment[], moduleSelected?: string) {
    let module = ModuleEnum.DeveloperProfile;

    if (moduleSelected === "Ownership") {
      module = ModuleEnum.DeveloperProfile;
    } else if (moduleSelected === "Stack") {
      module = ModuleEnum.Track;
    } else if (moduleSelected === "Assets") {
      module = ModuleEnum.AssetsLiabilities;
    } else if (moduleSelected === "ProofIncome") {
      module = ModuleEnum.ProofOfIncome;
    }

    if (files.length > 0) {
      //if case has no id it must be saved first
      if (this.caseid < 1) {
        const { attachments, developmentInput, ...onlyCase } = this.case;

        const postCase: CaseInsert = {
          ...onlyCase,
          developmentInput: null,
          developmentInputId: developmentInput.id,
        };
        this.caseCrudClient
          .post(postCase)
          .then((response) => {
            //Potentially unsafe cast
            this.case = response as Expand<Case, { readonly attachments: true; readonly developmentInput: true }>;
            this.onFileSelect(files, moduleSelected); //call itself and then exit as should now be saved so should be able to run
            return;
          })
          .finally(() => {
            this.dataLoading = false;
            this.openModal = false;
          });
        return;
      }

      this.dataLoading = true;
      this.fileAttachmentHelper
        .UploadFileLstInSync(files, this.uploadingFiles, this.caseid, this.fileUpload, module)
        .finally(() => {
          //this.calculateFilesForThisModule();
          this.openModal = false;
          this.dataLoading = false;
        });
    }
  }

  downloadFile(file: FileAttachment) {
    this.dataLoading = true;
    this.fileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  deleteFile(file: FileAttachment) {
    this.fileUpload.splice(this.fileUpload.indexOf(file), 1);
    this.fileAttachmentClient.markAsDeleted(file.id).then((result) => {});
  }

  calculateTotalFiles(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module === filter).length;
    }
    return this.total;
  }

  goToCaseDashboard(blockSave?: boolean): void {
    if (this.roleService.IsLender == true) {
      this.$location.path("/casedashboard/" + this.caseid);
    } else {
      if (blockSave) {
        this.save(true).then((response) => {
          this.$location.path("/casedashboard/" + this.caseid);
          (this.$rootScope as any).formSaved = true;
        });
      } else {
        this.save(false).then(() => {
          this.$location.path("/casedashboard/" + this.caseid);
        });
      }
    }
  }

  //save
  save(isFormComplete: boolean): ng.IPromise<number> {
    let defer = this.$q.defer<number>();

    this.saving = true;

    this.caseMemberClient
      .addUpdateReturnOnlyID(this.currentApplicant)
      .then((response) => {
        this.setAllFormsPristine();
        defer.resolve(response as number);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        this.error = true;
      })
      .finally(() => {
        this.saving = false;
      });

    return defer.promise;
  }

  formatDate(unformattedDate) {
    if (unformattedDate) {
      const formattedDate = new Date(unformattedDate.getTime() - unformattedDate.getTimezoneOffset() * 60000)
        .toISOString()
        .split("T")[0];

      return formattedDate;
    }
  }

  getAddressList(app: CaseMember, index: number, searchTerm: string) {
    let foundMatch = false;

    if (this.PostCodeOptions && this.PostCodeOptions[index] && this.PostCodeOptions[index].length > 0) {
      const addressLookup = this.PostCodeOptions[index].find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          this.currentShareholder.postalAddress = address;
          this.searchterm[index] = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.currentShareholder.postalAddress.addressLine1 = addressLookup.addressLine2;
        this.currentShareholder.postalAddress.addressLine2 = addressLookup.addressLine3;
        this.currentShareholder.postalAddress.addressLine3 = addressLookup.addressLine4;
        this.currentShareholder.postalAddress.addressLine4 = addressLookup.postCode;
        this.currentShareholder.postalAddress.postCode = addressLookup.addressLine1;
        this.searchterm[index] = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.PostCodeOptions[index] = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.PostCodeOptions[index] = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  saveDev(): void {
    this.saving = true;

    if (this.development.developmentTrackRecords === null || !this.development.developmentTrackRecords) {
      this.development.developmentTrackRecords = [];
    }

    //add a new one
    const newDevelopmentTrackRecord: DevelopmentTrackRecord = {
      developmentTrackRecordNumber: this.development.developmentTrackRecords.length + 1,
      developmentExperienceId: this.development.id,
      areaUnit: 1,
      developmentTrackRecordType: null,
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      } as PostalAddress,
      acquistionDate: null,
      acquistionCosts: 0,
      developmentAreas: "",
      buildCosts: 0,
      buildTime: 0,
      gdv: 0,
      soldOnExit: false,
      descriptionOfWorks: "",
      didYouUseDevelopmentFinance: false,
      ownerOrEmployee: OwnerOrEmployeeEnum.None,
      whatWasYourRole: "",
      developmentFinanceLenderName: "",
      developmentExperience: null,
      id: 0,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: 0,
      createdUserId: 0,
      createdUser: null,
      ownersApplicationUsers: [],
      ownersApplicationUserGroups: [],
    };

    this.formattedAcquisitionDate.forEach((d, index) => {
      this.development.developmentTrackRecords[index].acquistionDate = d;
    });

    this.developmenttrackrecordClient
      .addUpdate(newDevelopmentTrackRecord)
      .then((response) => {
        //update IDs
        this.development.developmentTrackRecords.push(response);
        this.setAllFormsPristine();
        this.saved = true;
      })
      .catch((error) => {
        this.error = true;
      })
      .finally(() => {
        this.saving = false;
      });
  }

  //resent forms
  setAllFormsPristine(): void {
    if (this.multiPartForm4) {
      this.multiPartForm4.$setPristine();
    }
    if (this.multiPartForm7) {
      this.multiPartForm7.$setPristine();
    }
  }

  removeDevelopment(item: DevelopmentTrackRecord) {
    if (item.id > 0) {
      this.developmenttrackrecordClient.markAsDeleted(item.id).then((response) => {
        if (response) {
          this.development.developmentTrackRecords.splice(this.development.developmentTrackRecords.indexOf(item), 1);
          this.formattedAcquisitionDate.splice(this.development.developmentTrackRecords.indexOf(item), 1);
        }
      });
    } else {
      //never saved so just remove
      this.development.developmentTrackRecords.splice(this.development.developmentTrackRecords.indexOf(item), 1);
    }
  }

  back(): void {
    if (this.step > 1) {
      this.step--;
      this.go("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/" + this.step);
      (this.$rootScope as any).formSaved = this.roleService.IsLender;
    } else if (this.step <= 1) {
      this.$location.path("/casedashboard/" + this.caseid);
    }
  }

  getAddressListArray(app: CaseMember, index: number, searchTerm: string) {
    let foundMatch = false;

    if (this.PostCodeOptions && this.PostCodeOptions[index] && this.PostCodeOptions[index].length > 0) {
      let addressLookup = this.PostCodeOptions[index].find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          app.postalAddress = address;
          this.searchterm[index] = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.development.developmentTrackRecords[index].postalAddress.addressLine1 = addressLookup.addressLine2;
        this.development.developmentTrackRecords[index].postalAddress.addressLine2 = addressLookup.addressLine3;
        this.development.developmentTrackRecords[index].postalAddress.addressLine3 = addressLookup.addressLine4;
        this.development.developmentTrackRecords[index].postalAddress.addressLine4 = addressLookup.postCode;
        this.development.developmentTrackRecords[index].postalAddress.postCode = addressLookup.addressLine1;
        this.searchterm[index] = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.PostCodeOptions[index] = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.PostCodeOptions[index] = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  initDevelopmentTrackRecordTypes() {
    this.development.developmentTrackRecords.forEach((r, index) => {
      this.developmentTrackRecordType[index] = {};
      for (let i = 1; i >= 0; i *= 2) {
        if (r.developmentTrackRecordType >= i) {
          //number is in enum sum, add it to object
          if (r.developmentTrackRecordType & i) {
            this.developmentTrackRecordType[index][i] = true;
          }
        } else {
          return;
        }
      }
    });
  }

  updateDevelopmentTrackRecordTypes(index: number, item: DevelopmentTrackRecordTypeEnum) {
    //if we are setting item to false and item exists, remove it, else add it
    if (
      this.developmentTrackRecordType[index][item] === true &&
      !!!(this.development.developmentTrackRecords[index].developmentTrackRecordType & item)
    ) {
      this.development.developmentTrackRecords[index].developmentTrackRecordType += item;
    } else {
      this.development.developmentTrackRecords[index].developmentTrackRecordType -= item;
    }
  }

  trackRecordFinish(): void {
    const developmentTrackRecords: DevelopmentTrackRecord[] = this.development.developmentTrackRecords.map(
      (record) => ({
        ...record,
        id: record.id,
        developmentExperience: null,
        lastModifiedUser: null,
        createdUser: null,
        ownersApplicationUsers: [],
        ownersApplicationUserGroups: [],
      }),
    );

    this.caseClient.developmentTrackrecordAddUpdateListReturnOnlyID(developmentTrackRecords).then(() => {
      this.$location.path("/casedashboard/" + this.caseid);
      (this.$rootScope as any).formSaved = true;
    });
  }

  go(path): void {
    // Only need to save if user is NOT a lender (everything is in read-only mode for lender)
    if (this.roleService.IsLender == true) {
      this.$location.path(path);
    } else {
      this.save(false).then((response) => {
        this.devexperienceId = response;
        this.$location.path(path);
      });
    }
  }

  async openSendToBorrower() {
    this.dataLoading = false;
    this.shareContext = 11;
    this.shareSuplId = this.devexperienceId;
    if ((await this.indexService.currentUser).userName !== this.case.developmentInput.ownerUser) {
      this.userFirstName = "";
    } else {
      this.userFirstName = (
        await getOneUsingOData(this.applicationUserCrudClient, {
          filter: { id: { eq: await this.indexService.currentUserId } },
          select: {
            firstName: true,
          },
        })
      ).firstName;
    }

    let message = `Please take a look to the track record. \n\nIf you need my help or want me to complete this information with you on a call, then please contact me as soon as possible.`;

    this.shareNote = `Dear ${this.shareFirstName != null ? this.shareFirstName + "," : " " + ","}\n\n` + message;

    this.caseMemberClient.fetchCaseMembersWithAccess(this.case.id).then((response: CaseMember[]) => {
      this.caseMembersWithAccess = response;

      this.showShare = true;
    });
  }

  sendToBorrower() {
    this.dataLoading = true;
    this.caseClient
      .sendNote(
        this.selectedClientToShareWith.firstName,
        this.selectedClientToShareWith.surname,
        this.selectedClientToShareWith.email,
        this.shareNote,
        this.case.id,
        this.shareContext,
        this.shareSuplId,
        this.case.developmentExperienceId,
      )
      .then((success) => {
        this.showShare = false;
        this.dataLoading = false;
        this.selectedClientToShareWith = null;
      });
  }

  isShareNoteFormComplete(): boolean {
    if (!this.selectedClientToShareWith) {
      return false;
    }

    if (this.shareNote == "undefined" || this.shareNote == null || this.shareNote.length == 0) {
      return false;
    }

    return true;
  }
}
